import { UserManagerRole } from "@medapro-types/UserManager/UserManager";
import api from "./api";
import endpoints from "./endpoints";

export default {
  getAll: async function (): Promise<UserManagerRole[]> {
    const response = await api.get(endpoints.roles.get, { params: {} });
    return response.data;
  },
  update: async function (model: UserManagerRole[]): Promise<{
    feedback: string;
  }> {
    const response = await api.post(endpoints.roles.update, model);
    return response.data;
  },
  delete: async function (listOfIds: string[]): Promise<string> {
    const response = await api.post(endpoints.roles.delete, listOfIds);
    return response.data;
  }
};
